import axios, { AxiosError } from 'axios';
import { IForgotPassword } from 'src/interfaces';

import http from './http';

class ForgotPasswordService {
  static forgotPassword(data: IForgotPassword) {
    return http
      .post('/auth/forgot-password', data)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static forgotPasswordWithDOB(data: { dob: string; email: string }) {
    return http
      .post('/auth/forgot-password', { ...data })
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default ForgotPasswordService;
